import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { GalleryItems } from './galleries.service';
import { ServiceBase } from './service.base';
import { SetupItems } from '../models/setupItems';

@Injectable({
  providedIn: 'root'
})
export class SeriesService extends ServiceBase {

  constructor(private http: HttpClient,
    authService: AuthService) {
    super(authService);
  }

  public getAllSeries(artTypeId: string | null = null): Observable<SetupItems[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Series';
    const method: string = '/fetch';
    var url = environment.BASE_API_PATH + api + method;
    if (artTypeId) {
      url += '/' + artTypeId;
    }
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public getArtistSeriesForGallery(artistId: string, artTypeId: string | null = null): Observable<SetupItems[]> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Series';
    const method: string = `/${artistId}/fetch`;
    var url = environment.BASE_API_PATH + api + method;
    if (artTypeId) {
      url += '/' + artTypeId;
    }
    return this.http.get<SetupItems[]>(url, httpOptions);
  }

  public saveSeries(series: SetupItems): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Series';
    const method: string = '/save';
    const url: string = environment.BASE_API_PATH + api + method;
    return this.http.post<ResponseObject>(url, series, httpOptions);
  }

  public deleteSeries(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Series';
    const method: string = '/deleteSeries/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public excludeSeries(Id: string): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const api: string = '/Series';
    const method: string = '/exclude/';
    const url: string = environment.BASE_API_PATH + api + method + Id;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }
}